import { State } from '../types';

const state: State = {
  isInitialized: false,
  isLoggedIn: false,
  isLoading: false,
  auth0UserId: '',
};

export default state;
